export default "__VITE_ASSET__0e9d780e__"